export default __webpack_public_path__ + "3366f2b5c328968d57b4dc16fd793779.png";